import React from "react";
import * as supplierActions from "../../actions/supplier/SupplierActions";
import * as purchaseActions from "../../actions/purchase/PurchaseActions";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import PurchaseStyles from "./PurchaseStyles";
import { Container, Divider, Grid, Button } from "@material-ui/core";
import { FormatNumberMXN } from "../common/Utils";
import useAuth from "../../hooks/useAuth";
import { bindActionCreators } from "redux";
import { toast, ToastContainer } from "react-toastify";

const PurchaseOrderDetailClientInformation = ({ classes, ...props }) => {
  const { isOCA, isOCV, isOCVA } = useAuth(props.orderDetail);
  const handleDownloadOrder = () => {
    debugger;
    console.log(props.orderDetail)
    if (props.orderDetail.consecutiveIndex) {
      props.supplierActions.download_oc(
        props.userLanguage,
        props.userToken,
        props.orderDetail.supplierId,
        props.orderDetail.nvpQuoteMultipleunits,
        props.orderDetail.consecutiveIndex,
        onError,
        onSuccess
      );
    } else {
      props.purchaseActions.download_order_details(
        props.userLanguage,
        props.userToken,
        props.orderDetail.id,
        onError,
        onSuccessDownload
      );
    }
  };

  const onSuccessDownload = (response) => {
    toast.success("Se completó la descarga correctamente", {
      className: classes.toastSuccess,
    });
  };


  const onSuccess = (response) => {
    // Convert Base64 string to Uint8Array
    const byteCharacters = atob(response.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    // Create Blob from Uint8Array
    const blob = new Blob([byteArray], { type: "application/pdf" });
    // Create URL for the Blob
    const url = URL.createObjectURL(blob);
    // Initiate download
    const link = document.createElement("a");
    link.href = url;
    link.download = response.fileDownloadName;
    link.click();
    // Cleanup
    URL.revokeObjectURL(url);

    toast.success("Se completó la descarga correctamente", {
        className: classes.toastSuccess,
      });
  };

  const onError = () => {
    toast.success("Ocurrió un error en la descarga, consulte al administrador", {
        className: classes.toastSuccess,
      });
  };
  return (
    <Container>
      <Grid item xs={12} className={classes.alignCenter}>
        <Grid item xs={12} className={classes.alignCenter}>
          <h5>Información de entrega</h5>
        </Grid>
        <Grid container className={classes.containerWithBorderRound}>
          <Grid item xs={12} className={classes.gridColor1}>
            <h5 className={classes.textColorWhite}>Información del cliente</h5>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Cliente</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>{props.orderDetail.client ?? props.orderDetail.client}</h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Nombre del usuario</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.clientUser ?? props.orderDetail.clientUser}
              </h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Tel Usuario</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.telephoneUser !== ""
                  ? props.orderDetail.telephoneUser
                  : "-"}
              </h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Persona que recibe</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.personWhoReceives ??
                  props.orderDetail.personWhoReceives}
              </h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Tel contacto</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.telephoneContact !== ""
                  ? props.orderDetail.telephoneContact
                  : "-"}
              </h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;Dirección</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.deliveryAddress ??
                  props.orderDetail.deliveryAddress}
              </h5>
            </Grid>
          </Grid>
        </Grid>
        {!isOCA && (
          <Grid container className={classes.containerWithBorderRound}>
            <Grid item xs={12} className={classes.gridColor1}>
              <h5 className={classes.textColorWhite}>
                Información del automóvil
              </h5>
            </Grid>
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={6}>
                <h5>&nbsp;&nbsp;&nbsp;Precio</h5>
              </Grid>
              <Grid item xs={6} className={classes.alignCenter}>
                <h5>
                  {props.orderDetail.finalPriceWithoutIva
                    ? FormatNumberMXN(props.orderDetail.finalPriceWithoutIva)
                    : "-"}
                </h5>
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={6}>
                <h5>&nbsp;&nbsp;&nbsp;IVA</h5>
              </Grid>
              <Grid item xs={6} className={classes.alignCenter}>
                <h5>
                  {props.orderDetail.ivaFinalPrice
                    ? FormatNumberMXN(props.orderDetail.ivaFinalPrice)
                    : "-"}
                </h5>
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={12}>
                <Divider variant="middle" />
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={6}>
                <h5>&nbsp;&nbsp;&nbsp;Precio con IVA</h5>
              </Grid>
              <Grid item xs={6} className={classes.alignCenter}>
                <h5>
                  {props.orderDetail.finalPrice
                    ? FormatNumberMXN(props.orderDetail.finalPrice)
                    : "-"}
                </h5>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid container className={classes.containerWithBorderRound}>
          <Grid item xs={12} className={classes.gridColor1}>
            <h5 className={classes.textColorWhite}>
              Características del automóvil
            </h5>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;&nbsp;Color exterior (primera opción)</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.external ?? props.orderDetail.external}
              </h5>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <h5>&nbsp;&nbsp;&nbsp;Color interior (primera opción)</h5>
            </Grid>
            <Grid item xs={6} className={classes.alignCenter}>
              <h5>
                {props.orderDetail.internal ?? props.orderDetail.internal}
              </h5>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className={classes.containerWithBorderRound}>
          <Grid item xs={12} className={classes.gridColor1}>
            <h5 className={classes.textColorWhite}>Accesorios del automóvil</h5>
          </Grid>
          {!isOCV && props.orderDetail.accesories && (
            <Grid container item xs={12} spacing={3}>
              <Grid item xs={6} className={classes.alignCenter}>
                <h5>Accesorio</h5>
              </Grid>
              <Grid item xs={6} className={classes.alignCenter}>
                <h5>Precio con IVA</h5>
              </Grid>
            </Grid>
          )}
          {props.orderDetail.accesories &&
            props.orderDetail.accesories.map((accessory, index) => {
              if (accessory.gift_accessory_ind == null || accessory.gift_accessory_ind == false) {
                return (
                  <Grid key={index} container item xs={12} spacing={3}>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <h5>{accessory.description}</h5>
                    </Grid>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <h5>
                        {accessory.amount
                          ? FormatNumberMXN(accessory.amount)
                          : "-"}
                      </h5>
                    </Grid>
                  </Grid>
                );
              }
              if (accessory.gift_accessory_ind) {
                return (
                  <Grid key={index} container item xs={12} spacing={3}>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <h5>{accessory.description}</h5>
                    </Grid>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <h5>Cortesía</h5>
                    </Grid>
                  </Grid>
                );
              }
            })}
        </Grid>
      </Grid>
      <br />
      <Grid item xs={12} className={classes.alignRight}>
        <Button
          onClick={handleDownloadOrder}
          size="small"
          variant="contained"
          color="primary"
        >
          Descargar Orden de Compra
        </Button>
      </Grid>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.UserProfileReducer.list,
  userlogin: state.LoginReducer.list,
  isUserAuthenticated: state.LoginReducer.isAuthenticated,
  userToken: state.LoginReducer.token,
  userLanguage: state.LoginReducer.language,
  navList: state.NavigationReducer.routeList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" }),
    supplierActions: bindActionCreators(supplierActions, dispatch),
    purchaseActions: bindActionCreators(purchaseActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(PurchaseStyles)(PurchaseOrderDetailClientInformation));
